import type { ITrainingPlan } from '@/data/training-plan-generator';
import { trainingPlanAtDate } from './trainingScheduleHistory';

/** Nutrition follows the effective schedule, never a not-yet-active profile preference. */
export function trainingNutritionHours(profileHours: number, plan: ITrainingPlan | null, date = new Date()): number {
  return trainingPlanAtDate(plan, date)?.weeklyAvailableHours ?? profileHours;
}

/** Preserve questionnaire answers separately from subsequent manual scheduling. */
export function questionnaireTrainingDays(profileDays: number[] | undefined, plan: ITrainingPlan | null) {
  return plan?.scheduleHistory?.find(version => version.effectiveFrom === '0000-01-01')?.trainingDays
    ?? plan?.trainingDays ?? profileDays;
}

/** A new diet template retains future scheduling but starts with today's nutrition hours. */
export function futureNutritionHours(currentHours: number, plan: ITrainingPlan | null, today: string) {
  const future = plan?.scheduleHistory?.filter(version => version.effectiveFrom > today)
    .map(version => ({ effectiveFrom: version.effectiveFrom, weeklyHours: version.weeklyAvailableHours ?? version.weeklyHours }));
  return future?.length ? [{ effectiveFrom: '0000-01-01', weeklyHours: currentHours }, ...future] : undefined;
}
